import React, { Component } from "react"
import config from "react-global-configuration"
import * as tracking from "../../helpers/tracking"
import * as cookieHelper from "../../../helpers/cookie"
import Spinner from "../spinner"
import * as dateHelper from "../../helpers/date"
import BookingAmendmentProducts from "../common/bookingAmendmentProducts"
import * as bookingHelper from "../../helpers/bookingHelper"
import BookingExtensionProducts from "../common/bookingExtensionProducts"
import * as moment from "moment"

class ParkingAmendmentList extends Component {
  static defaultProps = {
    autoSearch: true,
  }

  constructor(props) {
    super(props)

    this.state = {
      isActive: true,
      isTracked: false,
    }
  }

  componentDidMount() {
    const { arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode, changeFromBookingGuid, bookingExtension } = this.props
    if (this.props.bookingResults) this.props.removeBooking()
  }

  componentDidUpdate(prevProps) {
    const {
      autoSearch,
      arrivalDate,
      arrivalTime,
      departureDate,
      departureTime,
      voucher,
      affiliateCode,
      changeFromBooking,
      ammendmentReference,
      ammendmentEmail,
      bookingExtension,
    } = this.props

    const bookingChanged =
      prevProps.autoSearch !== autoSearch ||
      (!prevProps.changeFromBooking && changeFromBooking) ||
      (prevProps.changeFromBooking && changeFromBooking && prevProps.changeFromBooking.bguid !== changeFromBooking.bguid)

    if (bookingChanged && autoSearch && changeFromBooking && !this.props.isExtension) {
      this.props.performChangeBookingTime(
        changeFromBooking,
        arrivalDate,
        arrivalTime,
        departureDate,
        departureTime,
        voucher,
        affiliateCode,
        ammendmentReference,
        ammendmentEmail,
        true,
      )
    }

    if (!this.state.isTracked && this.props.userAccountDetails) {
      tracking.trackPageView(this.props, "parking amendment", "/virtual/(|en/|sv/)parkering/manage/edit-time")
      this.setState({ isTracked: true })
    }
  }

  trackSorting = (sortingKey) => {
    const parkingList = config.get("textKeys.parkingList")
    if (parkingList) {
      const sorting = parkingList.sorting
      const selectedSorting = sorting.options.find((option) => option.displayName === sortingKey)
      const userId = cookieHelper.getUserId(this.props)
      const data = {
        event: "track-event",
        eventCategory: "parking flow",
        eventAction: "product sort",
        eventLabel: selectedSorting.displayName,
        eventValue: 0,
        eventNoninteraction: true,
        userParkingArrivalDate: this.props.arrivalDate,
        userParkingDepartureDate: this.props.departureDate,
        pageBusinessunit: "parking",
        logged_in: cookieHelper.isLoggedIn(),
      }
      if (userId) data.userId = userId
      window.dataLayer.push(data)
    }
  }

  isFullValueCancellation = () => {
    if (this.props.manageBookingResult && this.props.manageBookingResult.cancellationInfo)
      return moment().isBefore(this.props.manageBookingResult.cancellationInfo.fullValueCancellationDeadline)
    return false
  }

  handleSortingSelection = (event) => {
    const sortingKey = event.target.selectedOptions[0].value
    this.trackSorting(event.target.selectedOptions[0].innerText)
    this.props.handleSorting(sortingKey)
  }

  renderSortingOption(displayName, sortingKey) {
    return (
      <option value={sortingKey} key={sortingKey}>
        {displayName}
      </option>
    )
  }

  getDate = (date) => {
    const day = dateHelper.formatDate(date, "dddd")
    const formattedDay = day.charAt(0).toUpperCase() + day.slice(1)
    const formattedDate = dateHelper.formatDate(date, "DD/MM/YYYY")
    return `${formattedDay} ${formattedDate}`
  }

  render() {
    if (!this.props.changeFromBooking) return null

    const {
      arrivalDate,
      arrivalTime,
      departureDate,
      departureTime,
      voucher,
      affiliateCode,
      changeFromBookingGuid,
      ammendmentReference,
      ammendmentEmail,
      originalBooking,
      userAccountDetails,
    } = this.props
    const { booking, carPark, product, parking, cancellationInfo, extras } = this.props.changeFromBooking

    const arrivalTimeChanged = !(booking.arrivalDate === arrivalDate && booking.arrivalTime === arrivalTime)
    const departureTimeChanged = !(booking.departureDate === departureDate && booking.departureTime === departureTime)

    const anyTimeChanged = arrivalTimeChanged || departureTimeChanged

    const selectedLanguage = this.props.languages.filter((x) => x.selected)[0]
    const dynamicPricingHelperTextFallback =
      selectedLanguage.language === "da"
        ? "Da priserne varierer, kan du opleve at din ændring kan være billigere eller dyrere end da du foretog din første booking. Priserne tager udgangspunkt i, hvad parkeringen koster i dag."
        : "As prices vary, you may experience that your change can be cheaper or more expensive than when you made your first booking. The prices are based on what the parking costs today."

    if (!anyTimeChanged) return null

    const { allProducts, focusOnContextBooking } = this.props

    const hasNoProducts = allProducts.length === 0

    const amendResultProduct = allProducts[0]

    const parkingList = config.get("textKeys.parkingList") || {}

    const textKeys = config.get("textKeys.amendment.manage") || {}

    let displayProducts = [...allProducts]
    let contextBookingNotAvailable = false
    if (focusOnContextBooking && this.props.changeFromBooking) {
      //    displayProducts = displayProducts.filter(item => item?.carPark?.name === this.props.changeFromBooking?.carPark?.name)
      displayProducts = displayProducts.filter((item) => item.product.id === this.props.changeFromBooking.booking.productId)
      if (displayProducts.length === 0) {
        contextBookingNotAvailable = true
        displayProducts = [...allProducts]
      }
    }

    const formerDurationHours = parseFloat(
      (new Date(`${booking.departureDate}T${booking.departureTime}`) - new Date(`${booking.arrivalDate}T${booking.arrivalTime}`)) / (1000 * 60 * 60),
    )
    const newDurationHours = parseFloat(
      (new Date(`${departureDate}T${departureTime}`) - new Date(`${arrivalDate}T${arrivalTime}`)) / (1000 * 60 * 60),
    )

    const durationDelta = Math.abs(newDurationHours - formerDurationHours)
    const durationShorted = newDurationHours < formerDurationHours
    const durationIsSame = newDurationHours === formerDurationHours
    const durationDeltaHours = durationDelta % 24
    const durationDeltaDays = (durationDelta - durationDeltaHours) / 24

    let timeChangeHeadline = durationIsSame
      ? textKeys.durationSame || "Du har rykket din booking"
      : durationShorted
        ? textKeys.durationShortened || "Du har forkortet din booking med"
        : textKeys.durationExtended || "Du har forlænget din booking med"

    if (durationDeltaDays > 1) {
      timeChangeHeadline += ` ${durationDeltaDays} ${textKeys.durationChangeDaysPlural || "dage"}`
    } else if (durationDeltaDays > 0) {
      timeChangeHeadline += ` ${durationDeltaDays} ${textKeys.durationChangeDaySingular || "dag"}`
    }

    // don't write 0 days

    if (durationDeltaDays > 0 && durationDeltaHours > 0) {
      timeChangeHeadline += ` ${textKeys.durationChangeAnd || "og"}`
    }

    if (durationDeltaHours > 1) {
      timeChangeHeadline += ` ${durationDeltaHours} ${textKeys.durationChangeHoursPlural || "timer"}`
    } else if (durationDeltaHours > 0) {
      timeChangeHeadline += ` ${durationDeltaHours} ${textKeys.durationChangeHourSingular || "time"}`
    }
    // don't write 0 hours

    //membership variables
    let changeFromMembership = booking?.membershipNumber ? true : false
    let loggedInMembership = userAccountDetails?.CustomerNumber ? true : false
    let hasLoggedInInfo = loggedInMembership || changeFromMembership ? true : false
    let membershipCarParks = [77, 71]

    //price variables
    const changeFromBookingPrice = booking.items.parkings[0].amount
    const membershipCarParksCheck = membershipCarParks.includes(amendResultProduct?.carPark?.id) && amendResultProduct?.result?.memberPrice
    const bookingResultPrice =
      membershipCarParksCheck && amendResultProduct?.result?.showMemberPrice && hasLoggedInInfo
        ? amendResultProduct?.result?.memberPrice
        : amendResultProduct?.result?.totalPrice || 0
    let deltaPrice = bookingResultPrice - changeFromBookingPrice
    let subtotal = bookingResultPrice

    let isPayment = bookingResultPrice > changeFromBookingPrice

    const confirmAndCheckoutButtonText = isPayment
      ? `${textKeys.confirmToPayment || "Bekræft & gå til betaling"}`
      : `${textKeys.confirmToOverview || "Gå til overblik"}`

    return (
      <div className="amendflow">
        <section className="deck deck--white">
          <Spinner isActive={this.props.ajaxSpinnerActive} isTransparent={this.props.ajaxSpinnerTransparent} />
          <div className="w--wider greybg">
            <div className="amenddata">
              <div className="data">
                <div className="grid">
                  <div className="grid-item col--12">
                    <h4>{timeChangeHeadline}</h4>
                  </div>
                  <div className="grid-groups grid-item col--12">
                    <div className="booking-time-flex-wrapper">
                      {arrivalTimeChanged ? (
                        <>
                          <div className="grid-line-one">
                            <div className="dataline strikethrough">{textKeys.formerArrivalLabel || "Gammel ankomsttid:"}</div>
                            <div className="dataline strikethrough">
                              {this.getDate(booking.arrivalDate)} ({booking.arrivalTime})
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {arrivalTimeChanged ? (
                        <>
                          <div className="grid-line-two">
                            <div className="dataline extra-margin-bottom">{textKeys.newArrivalLabel || "Ny ankomsttid"}</div>
                            <div className="dataline extra-margin-bottom">
                              {this.getDate(arrivalDate)} ({arrivalTime})
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}

                      {departureTimeChanged ? (
                        <>
                          <div className="grid-line-three">
                            <div className="dataline strikethrough">{textKeys.formerDepartureLabel || "Gammel udkørselstid:"}</div>
                            <div className="dataline strikethrough">
                              {this.getDate(booking.departureDate)} ({booking.departureTime})
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {departureTimeChanged ? (
                        <>
                          <div className="grid-line-four">
                            <div className="dataline">{textKeys.newDepartureLabel || "Ny udkørselstid"}</div>
                            <div className="dataline">
                              {this.getDate(departureDate)} ({departureTime})
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="clear"></div>
              </div>
            </div>
            {this.props.bookingExtension ? (
              <BookingExtensionProducts
                isUnavailable={false}
                originalBooking={booking}
                isUpsaleable={false}
                result={this.props.bookingExtension.result}
                carPark={this.props.bookingExtension.carPark}
                product={this.props.bookingExtension.product}
                extras={extras}
                noLastStyling={true}
                isAmendment={true}
                getExtraPrice={this.props.getExtraPrice}
                isFullValueCancellation={this.isFullValueCancellation}
                isExtendedRefundCancellation={this.isExtendedRefundCancellation}
                isCancelled
                {...this.props}
              />
            ) : amendResultProduct && !amendResultProduct.product.isSoldOut ? (
              <>
                <BookingAmendmentProducts
                  isUnavailable={false}
                  originalBooking={booking}
                  isUpsaleable={false}
                  result={amendResultProduct.result}
                  carPark={amendResultProduct.carPark}
                  product={amendResultProduct.product}
                  parking={amendResultProduct.parking}
                  extras={extras}
                  noLastStyling={true}
                  isAmendment={true}
                  getExtraPrice={this.props.getExtraPrice}
                  isFullValueCancellation={this.isFullValueCancellation}
                  isExtendedRefundCancellation={this.isExtendedRefundCancellation}
                  isCancelled
                  {...this.props}
                />
                {bookingHelper.getIdentifiedCampaignFlag(this.props.changeFromBooking.product, amendResultProduct.product) ? (
                  <div className="tip-wrapper">
                    <span className="info-tip"></span>
                    <div className="info-availability">
                      <p>{textKeys.campagneExpired || "Kampagnen er udløbet. For at få pladsen til kampagnepris skal du kontakte kundeservice."}</p>
                    </div>
                  </div>
                ) : null}
              </>
            ) : (
              <>
                <BookingAmendmentProducts
                  isUnavailable={true}
                  booking={booking}
                  carPark={carPark}
                  product={product}
                  extras={extras}
                  parking={parking}
                  noLastStyling={true}
                  isAmendment={true}
                  getExtraPrice={this.props.getExtraPrice}
                  isFullValueCancellation={this.isFullValueCancellation}
                  isExtendedRefundCancellation={this.isExtendedRefundCancellation}
                  isCancelled
                  {...this.props}
                />
                <div className="tip-wrapper">
                  <span className="soldout-tip"></span>
                  <div className="not-available">
                    <p>
                      {this.props.changeFromBooking?.carPark.name}{" "}
                      {parkingList.contextBookingNotAvailableWarning || "er ikke ledig i den ønskede periode. Vælg et andet P-anlæg"}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="w--wider">
            {amendResultProduct && !amendResultProduct.product.isSoldOut ? (
              <>
                <div className={/*"form--parking__calc"*/ null}>
                  <ul className="form--parking__calc__list">
                    {/* {this.props.changeFromBooking.booking.membershipNumber
                    ? <li><p>{textKeys.orderSubtotalText || "Subtotal"}</p><p> {subtotal} {textKeys.valuta || "DKK"}</p></li> */}
                    <li>
                      <p>{textKeys.orderSubtotalText || "Subtotal"}</p>
                      <p>{this.props.priceFormatter(subtotal)}</p>
                    </li>
                    {/* } */}

                    <li>
                      <p>{textKeys.orderPreviousPayment || "Tidligere betalt"}</p>
                      <p>{this.props.priceFormatter(changeFromBookingPrice)}</p>
                    </li>
                    <li>
                      <h4>
                        {deltaPrice === 0
                          ? "Total"
                          : deltaPrice > 0
                            ? textKeys.orderAdditionalPaymentMessage || "Du skal betale"
                            : textKeys.orderRefundMessage || "Du bliver refunderet"}
                      </h4>
                      <h4>{this.props.priceFormatter(deltaPrice)}</h4>
                    </li>
                  </ul>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <div className="w--wider button-group">
            {!hasNoProducts ? (
              <p className="helpertext w--normal">
                <i>{textKeys.dynamicPricingHelperText || dynamicPricingHelperTextFallback}</i>
              </p>
            ) : null}
            {amendResultProduct && !amendResultProduct.product.isSoldOut ? (
              <>
                <p className="confirm-button">
                  <button
                    className="button button--medium button--general"
                    onClick={() => this.props.handleReservation(amendResultProduct.product.id, amendResultProduct, null, true)}
                  >
                    {confirmAndCheckoutButtonText}
                  </button>
                </p>
                <p className="reselect-button">
                  <button
                    className="link"
                    onClick={() =>
                      this.props.performChangeBookingSearch(
                        this.props.changeFromBooking,
                        arrivalDate,
                        arrivalTime,
                        departureDate,
                        departureTime,
                        voucher,
                        affiliateCode,
                        ammendmentReference,
                        ammendmentEmail,
                        false,
                      )
                    }
                  >
                    {textKeys.editCarpark || "Vælg nyt P-Anlæg"}
                  </button>
                </p>
              </>
            ) : (
              <>
                <p>
                  <button
                    className="button button--medium button--general"
                    onClick={() =>
                      this.props.performChangeBookingSearch(
                        this.props.changeFromBooking,
                        arrivalDate,
                        arrivalTime,
                        departureDate,
                        departureTime,
                        voucher,
                        affiliateCode,
                        ammendmentReference,
                        ammendmentEmail,
                        false,
                      )
                    }
                  >
                    {textKeys.edit || "Vælg P-Anlæg"}
                  </button>
                </p>
              </>
            )}
          </div>
        </section>
      </div>
    )
  }
}

export default ParkingAmendmentList
